import React, { useState, useMemo, useCallback, useRef } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import DeleteModal from "../../Components/Common/DeleteModal";
import {
  Button,
  Col,
  Card,
  FormFeedback,
  Input,
  Label,
  Row,
  CardBody,
  Container,
} from "reactstrap";
import TableContainer from "../../Components/Common/TableContainer";

import {
  addRol,
  deleteRol,
  getRol,
  updateRol,
} from "../../slices/roles/thunks";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import ModalCreate from "../../Components/Common/Modal";

//Spiner Loading Page
const Spinner = ({ isLoading }: { isLoading: boolean }) => (
  isLoading ? (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 9999,
      }}
    >
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  ) : null
)

const RolList = () => {
  document.title = "Roles | Tren Taita Imbabura";

  const dispatch: any = useDispatch();
  const [roles, setRoles] = useState<any>([]);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [modal, setModal] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isFetching, setIsFetching] = useState<boolean>(false);
  const searchRequestRef = useRef<any>(null);

  const handleSearch = useCallback((searchValue: string) => {
    if (searchRequestRef.current) {
      searchRequestRef.current.abort();
    }
    
    setIsFetching(true);
    const params = searchValue ? { search: searchValue } : undefined;
    
    const request = dispatch(getRol(params));
    searchRequestRef.current = request;
    
    request.finally(() => {
      if (searchRequestRef.current === request) {
        setIsFetching(false);
      }
    });
  }, [dispatch]);

  const rol = useSelector((state: any) => state.Roles.rolLists);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setRoles(null);
    } else {
      setModal(true);
    }
  }, [modal]);

  const onClickDelete = (rol: any) => {
    setRoles(rol);
    setDeleteModal(true);
  };

  // Delete Rol
  const handleDeleteTask = async () => {
    setIsLoading(true)
    if (roles) {
      await dispatch(deleteRol(roles.id));
      setDeleteModal(false);
      validation.resetForm();
      setIsLoading(false)
    }
  };

  const validation: any = useFormik({
    enableReinitialize: true,

    initialValues: {
      name: (roles && roles.name) || "",
      // description: (roles && roles.description) || '',
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Por favor ingrese el nombre del rol"),
      // description: Yup.string().required("Por favor ingrese una descripción "),
    }),
    onSubmit: async (values) => {
      setIsLoading(true)
      if (isEdit) {
        const updatedForm = {
          id: roles.id,
          name: values.name,
          // description: values.description,
        };
        // Update rol
        dispatch(updateRol(updatedForm));
        validation.resetForm();
      } else {
        const newRol = {
          name: values["name"],
          // description: values["description"],
        };
        await dispatch(addRol(newRol));
        validation.resetForm();
      }
      toggle();
      setIsLoading(false)
    },
  });

  // Update Data
  const handleCustomerClick = useCallback(
    (arg: any) => {
      const roles = arg;

      setRoles({
        id: roles.id,
        name: roles.name,
        // description: roles.description,
      });
      //
      setIsEdit(true);
      toggle();
    },
    [toggle]
  );

  // Checked All

  const columns = useMemo(
    () => [
      {
        header: "Nombre",
        accessorKey: "name",
        enableColumnFilter: false,
      },
      {
        header: "Descripción",
        accessorKey: "description",
        enableColumnFilter: false,
      },

      {
        header: "Acciónes",
        enableColumnFilter: false,
        cell: (cell: any) => {
          return (
            <React.Fragment>
              <div className="d-flex flex-row-reverse">
                <div className="flex-grow-1 tasks_name"></div>
                <div className="flex-shrink-0 ms-4">
                  <ul className="list-inline">
                      <li className="list-inline-item">
                        <Button
                            className="btn btn-warning btn-sm"
                            onClick={() => {
                              const rolData = cell.row.original;
                              handleCustomerClick(rolData);
                            }}
                        >
                          <i className="ri-pencil-fill"></i>
                        </Button>
                      </li>
                      <li className="list-inline-item">
                        <Button
                            className="btn btn-danger btn-sm"
                            onClick={() => {
                              const rolData = cell.row.original;
                              onClickDelete(rolData);
                            }}
                        >
                          <i className="ri-delete-bin-fill"></i>
                        </Button>
                    </li>
                  </ul>
                </div>
              </div>
            </React.Fragment>
          );
        },
      },
    ],
    [handleCustomerClick]
  );

  return (
    <React.Fragment>
      <Spinner isLoading={isLoading}/>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteTask}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col>
              <Card>
              <CardBody>
                <div className="d-flex align-items-center mt-4 mb-2">
                  <h5 className="card-title mb-0 flex-grow-1 text-center fw-bold">
                    ROLES
                  </h5>
                  <div className="flex-shrink-0">
                    <div className="d-flex flex-wrap gap-2">
                      <button
                        className="btn btn-primary add-btn me-1"
                        onClick={() => {
                          setIsEdit(false);
                          validation.resetForm();
                          toggle();
                        }}
                        disabled={isLoading}
                      >
                        <i className="ri-add-line align-bottom me-1"></i>{" "}
                        Agregar rol
                      </button>
                    </div>
                  </div>
                </div>
                <div className="card-body pt-0">
                  <TableContainer
                    columns={columns}
                    data={rol || []}
                    isGlobalFilter={true}
                    customPageSize={10}
                    divClass="table-responsive table-card mb-3"
                    tableClass="align-middle table-nowrap mb-0"
                    theadClass="table-light"
                    SearchPlaceholder="Buscar..."
                    isFetching={isFetching}
                    onSearch={handleSearch}
                  />
                  <ToastContainer closeButton={false} limit={1} />
                </div>
              </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      <ModalCreate
        title={isEdit ? "Editar Rol" : "Crear Rol"}
        show={modal}
        handle={toggle}
        footer={
          <div className="hstack gap-2 justify-content-end">
            <Button
              type="button"
              onClick={() => {
                setModal(false);
                setRoles(null);
              }}
              className="btn-light"
            >
              Cerrar
            </Button>
            <button
              type="submit"
              className="btn btn-primary"
              id="add-btn"
              form="role-form"
            >
              {isEdit ? "Actualizar" : "Agregar"}
            </button>
          </div>
        }
      >
        <form
          id="role-form"
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          <div className="modal-body">
            <Row className="g-3">
              <Col lg={12}>
                <Label htmlFor="name" className="form-label">
                  Nombre
                </Label>
                <Input
                  name="name"
                  id="name"
                  className="form-control"
                  placeholder="Ingrese el nombre del rol"
                  type="text"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.name || ""}
                  invalid={!!(validation.touched.name && validation.errors.name)}
                />
                {validation.touched.name && validation.errors.name ? (
                  <FormFeedback type="invalid">
                    {validation.errors.name}
                  </FormFeedback>
                ) : null}
              </Col>
            </Row>
          </div>
        </form>
      </ModalCreate>
    </React.Fragment>
  );
};
export default RolList;
